/* eslint-disable import/prefer-default-export */
export const getSubdomain = () => {
  const { hostname } = window.location;
  if (hostname === "localhost" || hostname === "127.0.0.1") return "localhost";
  const parts = hostname.split(".");
  return parts.length > 2 ? parts[0] : "";
};
